import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Add Supported Document
export const addSupportedDocumentAPI = async (formData) => {
  try {
    let response;
    if (formData instanceof FormData) {
      response = await apiService.postFormData(endpoints.addSupportedDocument, formData);
    } else {
      response = await apiService.post(endpoints.addSupportedDocument, formData);
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Supported Document List
export const getSupportedDocumentsListAPI = async ({ 
  page = 1, 
  limit = 10, 
  search = "", 
  access_group_id = [],
  archived // New Parameter added here
} = {}) => {
  try {
    const params = { page, limit, search };

    // Add archived key if it exists
    if (archived !== undefined && archived !== null) {
      params.archived = archived;
    }

    // Handle array serialization for access_group_id
    if (access_group_id && Array.isArray(access_group_id) && access_group_id.length > 0) {
      params.access_group_id = access_group_id.join(',');
    }

    const response = await apiService.get(endpoints.getSupportedDocumentsList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Single Supported Document by ID
export const getSupportedDocumentByIdAPI = async (id) => {
  try {
    const response = await apiService.get(`${endpoints.getSupportedDocumentById}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Supported Document
export const updateSupportedDocumentAPI = async ({ id, formData }) => {
  try {
    let response;
    if (formData instanceof FormData) {
      response = await apiService.put(
        `${endpoints.updateSupportedDocument}/${id}`, 
        formData, 
        { headers: { "Content-Type": "multipart/form-data" } }
      );
    } else {
      response = await apiService.put(
        `${endpoints.updateSupportedDocument}/${id}`, 
        formData
      );
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Archive (Delete) Supported Document
// UPDATED: Now uses PATCH and sends body { "is_archive": true }
export const archiveSupportedDocumentAPI = async ({ id, is_archive = true }) => {
  try {
    const response = await apiService.patch(
      `${endpoints.archiveSupportedDocument}/${id}`,
      { is_archive } // Body payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

